import React from 'react';
import { Box } from '@mui/material';
import FormattedText from './FormattedText';
import MessageMediaFrame from './MessageMediaFrame';
import useMessageStyles from '../../../hooks/useMessageStyles';
import useInterveneTheme from '../../../hooks/useInterveneTheme';
import { useMessageBubbleContext } from './MessageBubbleContext';

export default function MediaMessage({ message }) {
  const { messageCaptionSx, messageRichStackSx } = useMessageStyles();
  const { chat } = useInterveneTheme();
  const { layoutProfile } = useMessageBubbleContext();
  const media = message.media || {};
  const { kind, url, caption } = media;
  const captionText = caption || message.text;
  const hasCaption = Boolean(captionText?.trim());

  if (!url && !captionText) {
    return (
      <Box sx={{ fontStyle: 'italic', color: chat.textMuted, fontSize: '14px' }}>
        Media unavailable
      </Box>
    );
  }

  return (
    <Box
      sx={{
        ...messageRichStackSx,
        maxWidth: { xs: 220, sm: 260 },
        width: '100%',
      }}
    >
      {url && (
        <MessageMediaFrame
          kind={kind || 'image'}
          url={url}
          alt="Shared media"
          bleed={layoutProfile?.isAttachmentPrimary || layoutProfile?.isCompactMedia}
          compact
        />
      )}
      {hasCaption && (
        <FormattedText text={captionText} sx={messageCaptionSx} />
      )}
    </Box>
  );
}
